const convertDateOverTime = (time) => {
    const intTime = time * 24 * 60 * 60
    const total_minutes = parseInt(Math.floor(intTime / 60));
    const total_hours = parseInt(Math.floor(total_minutes / 60));
    const days = parseInt(Math.floor(total_hours / 24)) !== 0 ? parseInt(Math.floor(total_hours / 24)) + 'd ' : '';

    const minutes = parseInt(total_minutes % 60) !== 0 ? parseInt(total_minutes % 60) + 'm ' : '';
    const hours = parseInt(total_hours % 24) !== 0 ? parseInt(total_hours % 24) + 'h ' : '';

    return days + hours + minutes;
}

export const convertDateOverTimeNew = (time) => {
    if (time !== 0 && !time) return
    if (time < -1.5) return null
    if (time === 0) return '0d'

    // tổng giây (làm tròn)
    const totalSeconds = Math.round(time * 24 * 60 * 60)
    const signNeg = totalSeconds < 0
    const absSec = Math.abs(totalSeconds)

    // Nếu khác 0 và < 1 giờ => tất cả quy về "1h" 
    if (absSec > 0 && absSec < 3600) return '1h'

    // tách ngày / giờ / phút từ giá trị tuyệt đối
    let days = Math.floor(absSec / 86400)
    let rem = absSec % 86400
    let hours = Math.floor(rem / 3600)
    let minutes = Math.floor((rem % 3600) / 60)

    // Nếu có giờ (>=1):
    //   - âm: bỏ phút (không làm tròn)
    //   - dương: nếu có phút >0 thì làm tròn lên 1 giờ
    if (hours >= 1) {
        if (!signNeg && minutes > 0) {
            hours += 1
        }
        // nếu signNeg thì bỏ phút -> không thay đổi hours
    }

    // quy đổi nếu hours >= 24
    if (hours >= 24) {
        const addDays = Math.floor(hours / 24)
        days += addDays
        hours = hours % 24
    }

    // text hiển thị:
    // - dương: "XdYh" (nếu có)
    // - âm: nếu có days (>0) thì "(-Xd)Yh" (days trong ngoặc, giờ hiển thị dương)
    //       nếu không có days thì "(-Y)h"
    let daysPart = ''
    let hoursPart = ''

    if (signNeg) {
        if (days > 0) {
            daysPart = `${-days}d`     // ví dụ -26h => -1d2h
            if (hours > 0) hoursPart = `${hours}h`
        } else {
            // chỉ có giờ (âm)
            if (hours > 0) hoursPart = `${-hours}h`
            else return '0d'
        }
    } else {
        if (days > 0) daysPart = `${days}d`
        if (hours > 0) hoursPart = `${hours}h`
    }

    const result = `${daysPart}${hoursPart}`
    return result === '' ? '0d' : result
}

export const convertDateOverTimeProgress = (time) => {
    const total_minutes = Math.floor(time * 60);
    const days = Math.floor(total_minutes / (24 * 60));
    const hours = Math.floor((total_minutes % (24 * 60)) / 60);
    const minutes = total_minutes % 60;

    const dayString = days > 0 ? days + 'd ' : '0d ';
    const hourString = hours > 0 ? hours + 'h ' : '0h ';
    const minuteString = minutes > 0 ? minutes + 'm ' : '0m ';

    return dayString + hourString + minuteString;
}

export default convertDateOverTime